import { RemoveLocationUser } from 'domain/usecases/remove-location-user';
import { BaseHttpService } from 'main/factories/http';

export class RemoteRemoveLocationUser extends BaseHttpService<RemoveLocationUser.Model> implements RemoveLocationUser {
  async removeLocationUser(params: RemoveLocationUser.Params): Promise<RemoveLocationUser.Model> {
    const queryParams = {
      userId: params.userId,
      email: params.email,
      locationId: params.locationId,
    };

    await this.request('delete', undefined, queryParams);
    return { status: 'ok' };
  }
}
